export default __webpack_public_path__ + "static/media/signature_drpramod.2b069b1a.png";